








































































import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import { Carrier } from '@/modules/Carrier/interfaces/carrier'
import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'
import {
  documentDeliveryKeys,
  documentDeliveryValues,
  yesOrNoKeys,
  yesOrNoValues
} from '@/modules/Carrier/helpers/carrier'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard
  }
})
export default class CarrierDetailDetail extends Vue {
  @Prop({ type: Object as () => Carrier }) readonly carrier!: Carrier

  contactInfoCard = [
    { title: 'Primary Address Street 1', content: '-' },
    { title: 'Email', content: '-' },
    { title: 'Primary Address Street 2', content: '-' },
    { title: 'Phone Number', content: '-' },
    { title: 'Primary Address City', content: '-' },
    { title: 'Fax Number', content: '-' },
    { title: 'Primary Address State', content: '-' },
    { title: 'Primary Address Zip/Postal Code', content: '-' }
  ]

  additionalInfoCard = [
    { title: 'Policy Document Delivery', content: '-' },
    { title: 'Endorsement Document Delivery', content: '-' },
    { title: 'Downloads', content: '-' }
  ]

  policyDocDeliveryVals = documentDeliveryKeys
  policyDocDeliveryOptions = documentDeliveryValues

  yesOrNoVals = yesOrNoKeys
  yesOrNoOptions = yesOrNoValues

  get notes () {
    if (!this.carrier || !this.carrier.notes) return ['-']
    return this.carrier.notes.split('\n')
  }

  @Watch('carrier', { deep: true })
  onCarrierUpdated (val: Carrier) {
    this.contactInfoCard[0].content = val.primaryAddressStreet1 || '-'
    this.contactInfoCard[1].content = val.email || '-'
    this.contactInfoCard[2].content = val.primaryAddressStreet2 || '-'
    this.contactInfoCard[3].content = val.phone ? formatPhoneNumber(val.phone, val.countryCode, val.extensionNumber) : '-'
    this.contactInfoCard[4].content = val.primaryAddressCity || '-'
    this.contactInfoCard[5].content = val.fax ? formatPhoneNumber(val.fax, val.faxCountryCode, val.faxExtensionNumber) : '-'
    this.contactInfoCard[6].content = val.primaryAddressState || '-'
    this.contactInfoCard[7].content = val.primaryAddressZipCode || '-'

    let policyDocDeliveryKey = '-'
    if (val.policyDocumentsDelivery) {
      const policyDocDeliveryIndex = this.policyDocDeliveryVals.findIndex((delivary: string) => {
        return delivary === val.policyDocumentsDelivery
      })
      policyDocDeliveryKey = this.policyDocDeliveryOptions[policyDocDeliveryIndex]
    }

    let endorsementDocDeliveryKey = '-'
    if (val.endorsementDocumentDelivery) {
      const endorsementDocDeliveryIndex = this.policyDocDeliveryVals.findIndex((delivary: string) => {
        return delivary === val.endorsementDocumentDelivery
      })
      endorsementDocDeliveryKey = this.policyDocDeliveryOptions[endorsementDocDeliveryIndex]
    }

    let downloadsKey = '-'
    if (val.downloads) {
      const policyDocDeliveryIndex = this.yesOrNoVals.findIndex((item: string) => {
        return item === val.downloads
      })
      downloadsKey = this.yesOrNoOptions[policyDocDeliveryIndex]
    }
    this.additionalInfoCard[0].content = policyDocDeliveryKey
    this.additionalInfoCard[1].content = endorsementDocDeliveryKey
    this.additionalInfoCard[2].content = downloadsKey
  }

  mounted () {
    this.onCarrierUpdated(this.carrier)
  }
}
